import { createIcon } from '@gluestack-ui/icon';
import Root from './styled-components/Root';
import { Root as IconRoot } from './styled-components';
export const Icon = createIcon({
    Root,
});
export * from './Icons';
const createIconUI = ({ ...props }) => createIcon({ Root: IconRoot, ...props });
export { createIconUI as createIcon };
